import * as React from 'react';
import './fileUpload.scss';
import { Primary } from 'rcd-cpp-ui/ui/button';

type Props = {
  disabled?: boolean;
  fileTypes?: string[];
  buttonLabel?: string;
  uploadFile: (file: File) => void;
  fileNamePlaceholder?: string;
};

export const FileUpload = ({
  disabled,
  fileTypes,
  buttonLabel,
  uploadFile,
  fileNamePlaceholder
}: Props) => {
  const ref = React.useRef(null);
  const [fileName, setFileName] = React.useState('');
  const showFileName = typeof fileNamePlaceholder == 'string';
  return (
    <div className="cpp-file-upload input-group">
      {showFileName && (
        <>
          <input
            className="form-control"
            placeholder={fileNamePlaceholder}
            type="text"
            value={fileName}
            disabled
          />
          <div className="input-group-append">
            <Primary
              label={buttonLabel || 'Upload'}
              onClick={() => {
                if (ref.current) {
                  ref.current.click();
                }
              }}
              disabled={disabled}
            />
          </div>
        </>
      )}
      {!showFileName && (
        <Primary
          label={buttonLabel || 'Upload'}
          onClick={() => {
            if (ref.current) {
              ref.current.click();
            }
          }}
          disabled={disabled}
        />
      )}
      <input
        type="file"
        onChange={e => {
          let file = null;
          if (e && e.target && e.target.files && e.target.files.length > 0) {
            file = e.target.files[0];
          }
          setFileName(file?.name || '');
          if (file) uploadFile(file);
        }}
        accept={fileTypes ? fileTypes.join(', ') : null}
        ref={ref}
      />
    </div>
  );
};
